import { motion, useAnimation, useInView } from 'framer-motion'
import { useEffect, useRef } from 'react'

import styled from 'styled-components'

function TextAnimation({ text, size = 3, width, style }) {
  const ctrls = useAnimation()
  const ref = useRef(null)
  const inView = useInView(ref, {
    amount: 0.5,
    once: true,
  })

  useEffect(() => {
    if (inView) {
      ctrls.start('visible')
    }
    if (!inView) {
      ctrls.start('hidden')
    }
  }, [ctrls, inView])

  const wordAnimation = {
    hidden: {},
    visible: {},
  }

  const characterAnimation = {
    hidden: {
      opacity: 0,
      y: 4,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: [0.2, 0.65, 0.3, 0.9],
      },
    },
  }

  return (
    <Title
      aria-label={text}
      role="heading"
      style={{ fontSize: `${size}rem`, width: `${width}`, ...style }}
    >
      {text.split(' ').map((word, index) => {
        return (
          <Word
            ref={ref}
            aria-hidden="true"
            key={index}
            initial="hidden"
            animate={ctrls}
            variants={wordAnimation}
            transition={{
              delayChildren: index * 0.25,
              staggerChildren: 0.05,
            }}
          >
            {word.split('').map((character, index) => {
              return (
                <Character
                  aria-hidden="true"
                  key={index}
                  variants={characterAnimation}
                >
                  {character}
                </Character>
              )
            })}
          </Word>
        )
      })}
    </Title>
  )
}
const Title = styled.h2`
  font-weight: 600;
`

const Word = styled(motion.span)`
  display: inline-block;
  margin-right: 0.25em;
  white-space: nowrap;
`

const Character = styled(motion.span)`
  display: inline-block;
  margin-right: -0.05em;
`

export default TextAnimation
